import React from "react";
import { Container, Row, Col } from "reactstrap";
import imgNotFound from "../../assets/images/not-found.png";
import { REACT_APP_PORTAL_URL } from "src/constant/environment";

const Error404 = () => {

  const handleToLogin = () => {
    window.location.href = REACT_APP_PORTAL_URL;
  };
  
  return (
    <React.Fragment>
      <div className="account-pages my-5">
        <Container>
          <Row className="justify-content-center">
            <Col xl={4} lg={5}>
              <div className="text-center">
                <div>
                  <img src={imgNotFound} alt="" className="img-fluid" />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="text-center">
              <h3 className="mt-3">This page was not found.</h3>
              <p className="text-muted mb-5">
                {" "}
                You may have mistyped the address or the page may have moved.
              </p>
              <button
                onClick={handleToLogin}
                className="btn btn-lg btn-primary mt-4"
              >
                Take Me back to Portal
              </button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Error404;
